import React from 'react';
import PropTypes from 'prop-types';
import { compose, pure } from 'recompose';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { ToDo, DrawRequestButton } from 'components/shared';

import { getApplication } from 'selectors';

const propTypes = {
  application: PropTypes.objectOf(PropTypes.any),
  match: PropTypes.objectOf(PropTypes.any).isRequired,
};

const defaultProps = {
  application: undefined,
};

function DrawRequestToDo({ application, match }) {
  const { token } = match.params;

  return (
    <ToDo>
      <ToDo.Title>You can Request Draw</ToDo.Title>
      <ToDo.Actions>
        {application && <DrawRequestButton application={application} token={token} size="sm" block />}
      </ToDo.Actions>
    </ToDo>
  );
}

DrawRequestToDo.propTypes = propTypes;
DrawRequestToDo.defaultProps = defaultProps;

const mapStateToProps = (state) => ({
  application: getApplication(state),
});

const enhance = compose(withRouter, connect(mapStateToProps), pure);

export default enhance(DrawRequestToDo);
